import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import FormField from '../../../component-library/form-field';
import FormSelect from '../../../component-library/form-select';
import ButtonIcon from '../../../component-library/button-icon';

const SearchBar = ({
	query,
	setQuery,
	pagination,
	setPagination,
	filter,
	setShowFilter,
	viewMode,
	setViewMode,
}) => {
	const navigate = useNavigate();
	const [searchString, setSearchString] = useState('');
	const pageSizeOptions = [
		{ id: '12', text: '12', value: 12 },
		{ id: '24', text: '24', value: 24 },
		{ id: '48', text: '48', value: 48 },
		{ id: '96', text: '96', value: 96 },
	];
	const sortFieldOptions = [
		{ id: 'name', text: 'Name', value: 'sortName' },
		{ id: 'dateUpdated', text: 'Updated Date', value: 'dateUpdated' },
	];

	const updatePageSize = e => {
		const newPageSize = Number(e.target.value);
		setQuery({
			...query,
			pageSize: newPageSize,
			pageOffset: 0,
		});
		setPagination({
			...pagination,
			currentPage: 1,
		});
		localStorage.setItem('StfUserPageSize', newPageSize);
	};

	const updateSortField = e => {
		const newSortField = e.target.value;
		setQuery({
			...query,
			sortField: newSortField,
			pageOffset: 0,
		});
		setPagination({
			...pagination,
			currentPage: 1,
		});
	};

	const updateSortOrder = sortOrder => {
		const newSortOrder = sortOrder;
		setQuery({
			...query,
			sortOrder: newSortOrder,
			pageOffset: 0,
		});
		setPagination({
			...pagination,
			currentPage: 1,
		});
	};

	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			if (query.searchString !== searchString) {
				navigate('./');
				setQuery({
					...query,
					pageOffset: 0,
					sortField: 'sortName',
					sortOrder: 'asc',
					searchString,
				});
				setPagination({
					...pagination,
					currentPage: 1,
				});
			}
		}, 1500);

		return () => clearTimeout(delayDebounceFn);
	}, [searchString]);

	return (
		<div className="search__search-bar">
			<div>
				<FormField
					type="search"
					placeholder="Search"
					action={e => { setSearchString(e.target.value); }}
					id="search_field"
					name="search_field"
					value={searchString}
					fullWidth
				/>
			</div>
			<div className="flex-row justify-flex-end">
				<div className="margin-right-4">
					<FormSelect
						action={e => { updateSortField(e); }}
						data={sortFieldOptions}
						id="sort_field"
						name="sort_field"
						value={query.sortField}
					/>
				</div>
				<div className="margin-right-24 margin-top-2">
					{query.sortOrder === 'asc' ? (
						<ButtonIcon
							icon="arrow-down-wide-short"
							title="Sort Descending"
							onClick={() => updateSortOrder('desc')}
						/>
					) : (
						<ButtonIcon
							icon="arrow-up-short-wide"
							title="Sort Ascending"
							onClick={() => updateSortOrder('asc')}
						/>
					)}
				</div>
				<FormSelect
					action={e => { updatePageSize(e); }}
					data={pageSizeOptions}
					id="page_size"
					name="page_size"
					value={query.pageSize}
				/>
				<div className="margin-left-24 margin-top-2">
					{viewMode === 'card' && (
						<ButtonIcon
							icon="list"
							title="List View"
							onClick={() => setViewMode('list')}
						/>
					)}
					{viewMode === 'list' && (
						<ButtonIcon
							icon="border-all"
							title="Card View"
							onClick={() => setViewMode('card')}
						/>
					)}
				</div>
				<div className="margin-left-24 margin-top-2">
					<ButtonIcon
						icon="filter"
						title="Filter"
						type={Object.keys(filter).length ? 'info' : ''}
						onClick={() => setShowFilter(true)}
					/>
				</div>
			</div>
		</div>
	);
};

export default SearchBar;

SearchBar.propTypes = {
	query: PropTypes.shape({
		searchString: PropTypes.string,
		sortField: PropTypes.string,
		sortOrder: PropTypes.string,
		pageSize: PropTypes.number,
	}).isRequired,
	setQuery: PropTypes.func.isRequired,
	pagination: PropTypes.shape({}).isRequired,
	setPagination: PropTypes.func.isRequired,
	filter: PropTypes.shape({}).isRequired,
	setShowFilter: PropTypes.func.isRequired,
	viewMode: PropTypes.string.isRequired,
	setViewMode: PropTypes.func.isRequired,
};
